import $ from 'jquery'

export class FullForm {

  constructor($container)
  {
			// this.$clone_form = $container.find('.full-form-clone-form')
  }

}
